$(function() {
    var source = location.pathname;
    var path = source.split("/");
    var url = "";
    if (path.length > 2) {
        url = "/" + path[1] + "/" + path[2];
    }
    $('nav#menu').mmenu({
        extensions: ['effect-slide-menu', 'pagedim-black', 'shadow-page'],
        counters: true,
        "navbar": {
            "add": true
        },
        navbars: [{
            position: 'top', // mm-navbar-top-1
            content: [
                'prev',
                'title',
                'close'
            ]
        },{
            position: 'top', // mm-navbar-top-2
            content: [
                '<h2><img src="./assets/img/logo.svg" alt="Chiesta" /></h2>'
            ]
        },{
            position: 'bottom',
            content: [
                '<li class="link-edit"><a href="' + url + '/setting/"><span class="ss-user">アカウント設定</span></a></li>',
                '<li class="link-logout"><a href="' + url + '/login/"><span class="ss-logout">ログアウト</span></a></li>'
            ]
        }]
    });
});

$(document).ready(function() {
  $("#my-menu").mmenu({
     // options
  }, {
     // configuration
     classNames: {
        fixedElements: {
           fixed: "header"
        }
     }
  });
});
